import { render, staticRenderFns } from "./NavigationLove.vue?vue&type=template&id=0baf738f&scoped=true&"
import script from "./NavigationLove.vue?vue&type=script&lang=js&"
export * from "./NavigationLove.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLove.vue?vue&type=style&index=0&id=0baf738f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf738f",
  null
  
)

export default component.exports